import { Component, OnInit } from '@angular/core';
import { CoursesComponent } from '../courses.component';

@Component({
    selector: 'app-rejected',
    templateUrl: './rejected.component.html',
    styleUrls: ['./rejected.component.scss'],
    imports: [CoursesComponent]
})
export class RejectedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
